import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "./style.css";
import { useStaggerReveal } from "../animation/scrollReveal";

const Education = () => {
  const containerRef = useStaggerReveal(".vertical-timeline-element", {
    alternateX: true,
    duration: 0.9,
    start: "top 88%",
  });
  return (
    <>
      <div
        style={{
          textAlign: "center",
          marginBottom: 30
        }}
        className="header"
      >
        <i className="fa fa-graduation-cap title-icon" />
        EDUCATION
      </div>
      <div className="page" ref={containerRef}>
        <VerticalTimeline lineColor="linear-gradient(180deg, var(--primary-color), var(--secondary-color))">
          {data.map((v, k) => (
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                background: "#ffffff",
                color: "var(--text-primary)",
                border: "1px solid var(--card-border)",
                borderRadius: "var(--radius)",
                boxShadow: "6px 6px 0px var(--bg-dark)"
              }}
              contentArrowStyle={{ borderRight: "7px solid var(--bg-dark)" }}
              date={v.duration}
              dateClassName="timeline-date"
              iconStyle={{
                background: "var(--primary-color)",
                color: "#ffffff",
                boxShadow: "4px 4px 0px var(--bg-dark)"
              }}
              icon={<GraduationIcon />}
              key={k}
            >
              <div className="vertical-timeline-element-title title" style={{ fontSize: "20px", marginBottom: "8px" }}>
                {v.name}
              </div>
              <span className="vertical-timeline-element-subtitle subtitle" style={{ color: "var(--primary-color)", fontWeight: 600 }}>
                {v.institute}
              </span>
              <p className="text-thin" style={{ marginTop: "12px" }}>{v.detail}</p>
            </VerticalTimelineElement>
          ))}
          {/* <VerticalTimelineElement
          iconStyle={{ 
            background: "linear-gradient(135deg, var(--accent-color), var(--secondary-color))", 
            color: "var(--text-primary)",
            boxShadow: "0 0 20px var(--glow-color)"
          }}
          icon={
            <i
              className="fa fa-star fa-2x timeline-icon"
              style={{ marginTop: "22%", marginLeft: "20%" }}
            />
          }
        /> */}
        </VerticalTimeline>
      </div>

    </>
  );
};

export default Education;

const GraduationIcon = () => {
  return (
    <i
      className="fa fa-graduation-cap fa-2x timeline-icon"
      style={{ marginTop: "22%", marginLeft: "18%", color: "var(--text-light)" }}
    />
  );
};

const data = [
  {
    duration: "2018- 2019",
    name: "Level 5 Diploma in Computing",
    institute: "NCC Education",
    detail:
      "Learned and practice Agile Methodology, Analysis, Design and Implementation, Computing Project, Database Design and Web Development.",
  },
  {
    duration: "2014 - 2018",
    name: "B.A (English)",
    institute: "Mandalay University of Distance Education",
    detail:
      "Graduated Bachelor of Arts in English language from Mandalay University of Distance Education.",
  },
  {
    duration: "2014-2016",
    name: "Post Graduated Diploma in English",
    institute: "MUFL",
    detail:
      "Post Graduated Diploma in English language from Mandalay University of Foreign Language.",
  },
  {
    duration: "2014 - 2015",
    name: "Diploma In IT",
    institute: "KMD Institute",
    detail:
      "Developing static and dynamic websites and window applications by using VB.NET, HTML, CSS, Java script and Microsoft SQL Database.",
  },
];
